/**
 * "Shop for me" page UI (sections/codeskin-shop-for-me.liquid).
 *
 * Flow: typed text -> structured intent (intent service if configured, else
 * CodeSkinAgent.parseIntentLocal) -> copied into the checklist -> the
 * checklist is the single source of truth -> CodeSkinAgent matches against the
 * catalog Liquid printed from Shopify -> cards with reasons.
 * Add to cart goes through window.codeskinCart (badge + toast), and checkout
 * is the normal cart -> Shopflo flow.
 */
(function () {
  'use strict';

  var INTENT_TIMEOUT_MS = 8000;

  function init(root) {
    var A = window.CodeSkinAgent;
    if (!A) return;

    var catalogEl = document.getElementById('codeskin-agent-catalog');
    var catalog = [];
    try {
      catalog = A.normalizeCatalog(JSON.parse(catalogEl ? catalogEl.textContent : '[]'));
    } catch (e) {
      catalog = [];
    }

    var els = {
      form: root.querySelector('[data-csfm-ask]'),
      text: root.querySelector('[data-csfm-text]'),
      submit: root.querySelector('[data-csfm-submit]'),
      budget: root.querySelector('[data-csfm-budget]'),
      reset: root.querySelector('[data-csfm-reset]'),
      understood: root.querySelector('[data-csfm-understood]'),
      understoodChips: root.querySelector('[data-csfm-understood-chips]'),
      unclear: root.querySelector('[data-csfm-unclear]'),
      source: root.querySelector('[data-csfm-source]'),
      status: root.querySelector('[data-csfm-status]'),
      results: root.querySelector('[data-csfm-results]'),
      debug: root.querySelector('[data-csfm-debug]'),
      debugJson: root.querySelector('[data-csfm-debug-json]')
    };
    var endpoint = (root.getAttribute('data-intent-endpoint') || '').trim();

    // Only offer choices that at least one product in the catalog has, plus the
    // full concern/skin lists (unknown data is still shown as "not listed").
    var categoriesInCatalog = A.VOCAB.category.filter(function (c) {
      return catalog.some(function (p) { return p.attrs.category === c; });
    });
    var chipOptions = {
      category: categoriesInCatalog,
      skin_types: A.VOCAB.skin_types,
      concerns: A.VOCAB.concerns,
      usage_time: ['am', 'pm']
    };

    var state = A.emptyIntent();
    var modeChosen = false; // true once the shopper picks Find products / Build my routine themselves
    var lastSource = '';
    var lastUnclear = [];

    // ---------------------------------------------------------------- checklist
    function renderChips() {
      Object.keys(chipOptions).forEach(function (key) {
        var wrap = root.querySelector('[data-csfm-chips="' + key + '"]');
        if (!wrap) return;
        wrap.innerHTML = '';
        chipOptions[key].forEach(function (value) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'csfm__chip';
          b.textContent = A.label(value);
          b.setAttribute('data-value', value);
          b.setAttribute('aria-pressed', 'false');
          b.addEventListener('click', function () { toggleChip(key, value); });
          wrap.appendChild(b);
        });
      });
    }

    function toggleChip(key, value) {
      if (key === 'category' || key === 'usage_time') {
        state[key] = state[key] === value ? null : value;
      } else {
        var list = state[key].slice();
        var i = list.indexOf(value);
        if (i === -1) list.push(value); else list.splice(i, 1);
        state[key] = list;
      }
      lastSource = 'checklist';
      run();
    }

    function syncChecklist() {
      Object.keys(chipOptions).forEach(function (key) {
        root.querySelectorAll('[data-csfm-chips="' + key + '"] .csfm__chip').forEach(function (b) {
          var v = b.getAttribute('data-value');
          var on = Array.isArray(state[key]) ? state[key].indexOf(v) !== -1 : state[key] === v;
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      });
      els.budget.value = state.max_price || '';
      root.querySelectorAll('[data-csfm-flag]').forEach(function (cb) {
        var k = cb.getAttribute('data-csfm-flag');
        cb.checked = k === 'white_cast' ? state.white_cast === false : state[k] === true;
      });
      root.querySelectorAll('[data-csfm-mode]').forEach(function (r) { r.checked = r.value === state.mode; });
    }

    els.budget.addEventListener('change', function () {
      var v = parseInt(els.budget.value, 10);
      state.max_price = v > 0 ? v : null;
      lastSource = 'checklist';
      run();
    });
    root.querySelectorAll('[data-csfm-flag]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        var k = cb.getAttribute('data-csfm-flag');
        if (k === 'white_cast') state.white_cast = cb.checked ? false : null;
        else state[k] = cb.checked ? true : null;
        lastSource = 'checklist';
        run();
      });
    });
    root.querySelectorAll('[data-csfm-mode]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        state.mode = r.value === 'routine' ? 'routine' : 'products';
        modeChosen = true;
        run();
      });
    });
    els.reset.addEventListener('click', function () {
      state = A.emptyIntent();
      modeChosen = false;
      lastUnclear = [];
      lastSource = '';
      els.text.value = '';
      run();
    });

    // ---------------------------------------------------------------- typed text
    function intentFromService(text) {
      if (!endpoint) return Promise.reject(new Error('no endpoint'));
      var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timer = controller ? setTimeout(function () { controller.abort(); }, INTENT_TIMEOUT_MS) : null;
      return fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ text: text }),
        signal: controller ? controller.signal : undefined
      }).then(function (res) {
        if (timer) clearTimeout(timer);
        if (!res.ok) throw new Error('intent service ' + res.status);
        return res.json();
      }).then(function (data) {
        return A.sanitizeIntent(data && data.intent ? data.intent : data);
      });
    }

    function understand(text) {
      els.submit.disabled = true;
      els.status.textContent = 'Understanding your request…';
      return intentFromService(text)
        .then(function (intent) { lastSource = 'ai'; return intent; })
        .catch(function () { lastSource = 'keywords'; return A.parseIntentLocal(text); })
        .then(function (intent) {
          els.submit.disabled = false;
          lastUnclear = intent.unclear || [];
          // Typed text replaces the previous request; the shopper can then
          // fine-tune it in the checklist.
          // Routine if the text asks for one, else keep the mode only when the
          // shopper picked it themselves.
          var mode = intent.mode === 'routine' ? 'routine' : (modeChosen ? state.mode : 'products');
          state = A.sanitizeIntent(intent);
          state.mode = mode;
          run();
        });
    }

    els.form.addEventListener('submit', function (e) {
      e.preventDefault();
      var text = els.text.value.trim();
      if (!text) { els.text.focus(); return; }
      understand(text);
    });
    els.text.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); els.form.requestSubmit ? els.form.requestSubmit() : els.form.submit(); }
    });
    root.querySelectorAll('[data-csfm-example]').forEach(function (b) {
      b.addEventListener('click', function () {
        els.text.value = b.textContent.trim();
        understand(els.text.value);
      });
    });

    // ---------------------------------------------------------------- rendering
    function money(paise) { return '₹' + A.rupees(paise).toLocaleString('en-IN'); }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function hasRequest() {
      return !!(state.category || state.skin_types.length || state.concerns.length || state.max_price ||
        state.usage_time || state.white_cast === false || state.spf_min || state.pregnancy_safe ||
        state.fragrance_free || state.finish || state.mode === 'routine');
    }

    function renderUnderstood() {
      var tags = [];
      if (state.mode === 'routine') tags.push(['Goal', 'Build a routine']);
      if (state.category) tags.push(['Product type', A.label(state.category)]);
      if (state.skin_types.length) tags.push(['Skin type', state.skin_types.map(A.label).join(', ')]);
      if (state.concerns.length) tags.push(['Concerns', state.concerns.map(A.label).join(', ')]);
      if (state.usage_time) tags.push(['Use', A.label(state.usage_time)]);
      if (state.max_price) tags.push(['Max price', '₹' + state.max_price.toLocaleString('en-IN')]);
      if (state.spf_min) tags.push(['SPF', state.spf_min + '+']);
      if (state.white_cast === false) tags.push(['Requirement', 'No white cast']);
      if (state.fragrance_free) tags.push(['Requirement', 'Fragrance-free']);
      if (state.pregnancy_safe) tags.push(['Requirement', 'Pregnancy-safe']);
      if (state.finish) tags.push(['Finish', A.label(state.finish)]);

      els.understood.hidden = !tags.length && !lastUnclear.length;
      els.understoodChips.innerHTML = tags.map(function (t) {
        return '<span class="csfm__tag"><b>' + esc(t[0]) + '</b> ' + esc(t[1]) + '</span>';
      }).join('');
      els.unclear.hidden = !lastUnclear.length;
      els.unclear.textContent = lastUnclear.join(' ');
      els.source.textContent = lastSource === 'ai' ? 'Understood by AI · edit with the checklist'
        : lastSource === 'keywords' ? 'Understood from keywords · edit with the checklist'
          : lastSource === 'checklist' ? 'From your checklist' : '';
    }

    function cardHtml(r, best) {
      var p = r.product;
      var pct = Math.round(r.score * 100);
      return '' +
        '<article class="csfm__card">' +
          '<a class="csfm__card-top" href="' + esc(p.url) + '">' +
            (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy" width="400" height="400">' : '') +
            '<span class="csfm__score' + (best ? ' csfm__score--best' : '') + '">' + pct + '% match</span>' +
          '</a>' +
          '<div class="csfm__card-body">' +
            '<a class="csfm__card-title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            '<span class="csfm__price">' + money(p.price) + (p.variant && p.variant.title && p.variant.title !== 'Default Title' ? ' <small>· ' + esc(p.variant.title) + '</small>' : '') + '</span>' +
            (r.reasons.length ? '<ul class="csfm__list csfm__list--good">' + r.reasons.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>' : '') +
            (r.conflicts.length ? '<ul class="csfm__list csfm__list--warn">' + r.conflicts.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>' : '') +
            '<div class="csfm__card-actions">' +
              '<button type="button" class="csfm__btn csfm__btn--dark" data-csfm-add="' + esc(p.variant ? p.variant.id : '') + '">Add to cart</button>' +
              '<a href="' + esc(p.url) + '" class="csfm__card-title" style="font-size:13px">View</a>' +
            '</div>' +
          '</div>' +
        '</article>';
    }

    function renderProducts() {
      var results = A.matchProducts(state, catalog);
      if (!results.length) {
        els.results.innerHTML = '<div class="csfm__empty">No product matches all of that yet. Try removing a requirement or raising the budget.</div>';
        els.status.textContent = '';
        return { results: [] };
      }
      els.status.textContent = results.length + (results.length === 1 ? ' product matches' : ' products match') + ' your request';
      els.results.innerHTML = results.map(function (r, i) { return cardHtml(r, i === 0 && r.score >= 0.75); }).join('');
      return { results: results };
    }

    function renderRoutine() {
      var ro = A.buildRoutine(state, catalog);
      if (!ro.steps.length) {
        els.results.innerHTML = '<div class="csfm__empty">We could not build a routine from the current catalog.</div>';
        els.status.textContent = '';
        return { routine: ro };
      }
      var over = ro.budget && !ro.within_budget;
      els.status.textContent = '';
      els.results.innerHTML = '' +
        '<section class="csfm__routine" aria-label="Your routine">' +
          '<div class="csfm__routine-head">' +
            '<h2>Your ' + (ro.time === 'am' ? 'morning' : 'night') + ' routine</h2>' +
            '<span class="csfm__routine-total' + (over ? ' csfm__routine-total--over' : '') + '">Total ₹' + ro.total.toLocaleString('en-IN') +
              (ro.budget ? (over ? ' · over your ₹' + ro.budget.toLocaleString('en-IN') + ' budget (cheapest matching set)' : ' · within your ₹' + ro.budget.toLocaleString('en-IN') + ' budget') : '') +
            '</span>' +
          '</div>' +
          ro.steps.map(function (s, i) {
            var p = s.result.product;
            return '<div class="csfm__step">' +
              '<span class="csfm__step-num">' + (i + 1) + '</span>' +
              (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="72" height="72">' : '<span></span>') +
              '<div class="csfm__step-info">' +
                '<span class="csfm__step-name">' + esc(s.name) + '</span>' +
                '<a class="csfm__card-title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
                '<span class="csfm__price">' + money(p.price) + '</span>' +
                (s.result.reasons.length ? '<ul class="csfm__list csfm__list--good">' + s.result.reasons.slice(0, 3).map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>' : '') +
              '</div>' +
              '<button type="button" class="csfm__btn csfm__btn--ghost" data-csfm-add="' + esc(p.variant ? p.variant.id : '') + '">Add</button>' +
            '</div>';
          }).join('') +
          (ro.missing_steps.length ? '<p class="csfm__unclear">No product found for: ' + esc(ro.missing_steps.join(', ')) + '.</p>' : '') +
          '<div><button type="button" class="csfm__btn csfm__btn--primary" data-csfm-add-all="' +
            esc(ro.steps.map(function (s) { return s.result.product.variant ? s.result.product.variant.id : ''; }).filter(Boolean).join(',')) +
          '">Add whole routine to cart</button></div>' +
        '</section>';
      return { routine: ro };
    }

    function renderDebug(output) {
      var payload = {
        request: state,
        understood_by: lastSource || null,
        output: output.routine ? {
          routine: {
            time: output.routine.time, total_inr: output.routine.total, budget_inr: output.routine.budget,
            within_budget: output.routine.within_budget, missing_steps: output.routine.missing_steps,
            steps: output.routine.steps.map(function (s) { return { step: s.name, product: s.result.product.handle, score: s.result.score }; })
          }
        } : {
          products: (output.results || []).map(function (r) {
            return {
              product_id: r.product.id, handle: r.product.handle, title: r.product.title,
              price_inr: A.rupees(r.product.price), available: r.product.available,
              variant_id: r.product.variant ? r.product.variant.id : null,
              match_score: r.score, reasons: r.reasons, conflicts: r.conflicts,
              attributes: r.product.attrs, attribute_sources: r.product.source
            };
          })
        }
      };
      els.debug.hidden = false;
      els.debugJson.textContent = JSON.stringify(payload, null, 2);
    }

    function run() {
      syncChecklist();
      renderUnderstood();
      if (!catalog.length) {
        els.results.innerHTML = '<div class="csfm__empty">The product catalog could not be loaded.</div>';
        return;
      }
      if (!hasRequest()) {
        els.results.innerHTML = '<div class="csfm__empty">Describe what you need above, or pick from the checklist to see matching products.</div>';
        els.status.textContent = '';
        els.debug.hidden = true;
        return;
      }
      var output = state.mode === 'routine' ? renderRoutine() : renderProducts();
      renderDebug(output);
    }

    // ---------------------------------------------------------------- cart
    root.addEventListener('click', function (e) {
      var one = e.target.closest('[data-csfm-add]');
      var all = e.target.closest('[data-csfm-add-all]');
      var cart = window.codeskinCart;
      if (one) {
        var id = one.getAttribute('data-csfm-add');
        if (!id) return;
        if (cart && cart.addVariant) cart.addVariant(id, 1);
        else fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) });
      } else if (all) {
        var ids = all.getAttribute('data-csfm-add-all').split(',').filter(Boolean);
        if (!ids.length) return;
        if (cart && cart.addMultipleVariants) cart.addMultipleVariants(ids);
        else {
          var items = ids.map(function (v) { return { id: Number(v), quantity: 1 }; });
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
        }
      }
    });

    renderChips();
    run();
  }

  function boot() {
    document.querySelectorAll('[data-codeskin-shop-for-me]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
